import React, { useEffect, useState } from 'react'
import { Icon, Link } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { BREADCRUMBS_DATA } from '../../utils/prop-type-shape'
import { componentNames, fptiTypes } from '../../utils/analytics/fpti-constants'

//styles
import './breadcrumbs.less'

// Hooks
import useTracking from '../../hooks/useTracking'
import { useHelper } from '../../hooks/useHelper'

function Breadcrumbs({ breadCrumbTitle, breadCrumbPath }) {
  const [topicTitle, setTopicTitle] = useState(null)
  const [articleTitle, setArticleTitle] = useState(null)
  const [topicPath, setTopicPath] = useState(null)
  const { trackClick } = useTracking()

  //Hooks
  const { generateLinkWithCoBrand } = useHelper()

  useEffect(() => {
    if (breadCrumbTitle && breadCrumbPath) {
      const [currentTopicTitle, currentArticleTitle] =
        breadCrumbTitle.split('/')
      const [currentTopicPath] = breadCrumbPath.split('/')
      setTopicTitle(currentTopicTitle)
      setArticleTitle(currentArticleTitle)
      setTopicPath(currentTopicPath)
    }
  }, [breadCrumbTitle, breadCrumbPath])

  const isTopicLinkExist = () => topicPath && topicTitle

  const onClickHandler = (e, topic) => {
    e.stopPropagation()
    trackClick({
      name: componentNames.BREADCRUMB,
      type: fptiTypes.ON_CLICK,
      link: `breadcrumb|${topic}|clicked`,
    })
  }

  const renderTopicLink = () => {
    if (isTopicLinkExist()) {
      return (
        <>
          <Icon
            className="hc-breadcrumb__link_separator"
            name="chevron-down"
            size="xs"
          />
          <Link
            href={generateLinkWithCoBrand(`/smarthelp/topic/${topicPath}`)}
            data-testid="hc-breadcrumb-topic-link"
            onClick={(e) => onClickHandler(e, topicPath)}
          >
            {topicTitle}
          </Link>
        </>
      )
    }
    return null
  }

  const renderArticleLink = () => {
    if (isTopicLinkExist() && articleTitle) {
      return (
        <>
          <Icon
            className="hc-breadcrumb__link_separator"
            name="chevron-down"
            size="xs"
          />
          <Link
            href={generateLinkWithCoBrand(`/smarthelp/topic/${topicPath}`)}
            data-testid="hc-breadcrumb-article-link"
            onClick={(e) => onClickHandler(e, topicPath)}
          >
            {articleTitle}
          </Link>
        </>
      )
    }
    return null
  }

  return (
    <div
      className="hc-breadcrumb__container"
      data-testid="hc-breadcrumb-container"
    >
      <Link
        href={generateLinkWithCoBrand('/smarthelp/home')}
        data-testid="hc-breadcrumb-home-link"
      >
        <Message id="app.helpcenter.home" />
      </Link>
      {renderTopicLink()}
      {renderArticleLink()}
    </div>
  )
}

Breadcrumbs.propTypes = BREADCRUMBS_DATA

export default Breadcrumbs
